<template>
	<div>
		<Mobile />
		<!-- <ChatComponent /> -->
		<Navigation />
		<div id="main">
			<div class="section__first__spacing"></div>
			
			<router-view />
			<Footer />
		</div>
	</div>
</template>

<script>
import Navigation from "@/components/navigation/Navigation.vue";
import Footer from "@/components/footer.vue";
// import ChatComponent from "@/components/ChatComponent.vue";
import Mobile from "@/components/Mobile.vue";

export default {
	components: {
		Navigation,
		Footer,
		// ChatComponent,
		Mobile
	},
};
</script>